import api from '../../util/api'
import _ from 'lodash'
import Util from '@/util'

const state = {
  selectedConfig: {},
  config: {},
  preferences: {
    minsPerShipmentEstimate: 3,
    minsPerShipmentEstimateTopShelf: 5,
    minsTillFlaggedAsOverdue: 10,
    minsTillCompletedDisappear: 10,
  },
}

const getters = {
  config: (state) => {
    return state.config
  },
  selectedConfig: (state) => {
    return state.selectedConfig
  },
  preferences: (state) => {
    return state.preferences
  },
}

const actions = {
  getConfig({ commit, dispatch }, args) {
    api
      .getConfig()
      .then((response) => {
        commit('setConfig', response.data)

        var config = {}
        var selected = localStorage.getItem('selected_config') ? JSON.parse(Util.atobUtf8(localStorage.getItem('selected_config'))) : undefined
        if (selected && selected.AccountName) {
          config = _.find(response.data, { AccountName: selected.AccountName })
        } else {
          config = response.data[0]
        }

        commit('setSelectedConfig', config)

        var preferences = localStorage.getItem('preferences')
        if (preferences) {
          commit('setPreferences', JSON.parse(preferences))
        }

        args.callback()
      })
      .catch((e) => {
        dispatch('handleError', e, { root: true })
      })
  },
  setConfig({ commit }, config) {
    if (!config || !config.AccountName) return
    commit('setSelectedConfig', config)
  },
  setPreferences({ commit }, preferences) {
    commit('setPreferences', preferences)
  },
}

const mutations = {
  setConfig(state, config) {
    state.config = config
  },
  setSelectedConfig(state, config) {
    state.selectedConfig = config
    localStorage.setItem('selected_config', Util.btoaUtf8(JSON.stringify(state.selectedConfig)))
  },
  setPreferences(state, preferences) {
    state.preferences = preferences
    localStorage.setItem('preferences', JSON.stringify(state.preferences))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
